import { styled } from '@mui/material/styles';
import { MenuItem } from '@mui/material';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';

export const StyledVoicePresetDialog = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  .voice-preset-input {
    height: 44px;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  padding: 8px 12px;
  box-sizing: border-box;
  grid-template-columns: 50px 100px;
  grid-gap: 10px;
  display: grid;
  cursor: pointer;
  width: 100%;
  color: ${(props) => props.active && COLOR.darkBlue};
  background-color: ${(props) => props.active && '#1E164E14'};
  gap: 10px;
  border-radius: 8px !important;
  &:hover {
    color: ${(props) => (props.active ? COLOR.darkBlue : COLOR.text)};
    background-color: ${(props) =>
      props.active ? '#1E164E14' : TRANSPARENT_COLOR.dark};
  }
`;

export const StyledPunctuation = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .punctuation-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    .punctuation-title {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }
`;

export const StyledPunctuationList = styled('div')`
  display: flex;
  flex-wrap: wrap;
  row-gap: 12px;
  column-gap: 32px;
  .client-pause-item {
    width: 47%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
  .client-pause-title {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .client-pause-icon {
    width: 24px;
    height: 24px;
  }
  .number-input-wrapper {
    width: 132px;
  }
  .dashed-border {
    .MuiInputBase-input {
      border-left: 1px solid ${COLOR.secondary[16]};
      border-right: 1px solid ${COLOR.secondary[16]};
      color: ${COLOR.darkBlue};
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.4px;
      padding: 0;
      height: 32px;
    }
    .MuiOutlinedInput-notchedOutline {
      border-radius: 8px;
      border: 1px solid ${COLOR.secondary[16]};
    }
  }
  .icon-input {
    cursor: pointer;
    font-size: 16px;
    color: ${COLOR.darkBlue};
  }
`;
